<template>
  <OutstandingRequirement></OutstandingRequirement>
</template>
<script type="text/javascript">
import { OutstandingRequirement } from '../components'
export default {
  name: 'LifeoutstandingRequirementContainer',
  components: {
    OutstandingRequirement
  }
}

</script>



// WEBPACK FOOTER //
// src/Osm/LifePolicy/containers/LifeOutstandingRequirementContainer.vue